'use client'; // Error boundaries must be Client Components

// import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { Button } from '@/components/catalyst/button';
import { Heading } from '@/components/catalyst/heading';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    // Sentry.captureException(error);
  }, [error]);

  return (
    <div>
      <Heading>Something went wrong!</Heading>
      <div className='my-3 font-bold'>
        There was a problem accessing that resource.
      </div>
      <Button onClick={() => reset()}>Try again</Button>
    </div>
  );
}
